<h1 mat-dialog-title>
    Cadastrar novo condutor na multa
</h1>

<button mat-icon-button mat-dialog-close>
    <mat-icon>close</mat-icon>
</button>

<mat-horizontal-stepper [linear]="false" #stepper>
    <mat-step [stepControl]="formCondutor.form">
        <ng-template matStepLabel>Dados Pessoais</ng-template>
        <app-form [campos]="camposDadosCondutor" appearance="outline" #formCondutor></app-form>
    </mat-step>

    <mat-step [stepControl]="formCNH.form">
        <ng-template matStepLabel>Dados CNH</ng-template>
        <app-form [campos]="camposDadosCNH" appearance="outline" #formCNH></app-form>
    </mat-step>
</mat-horizontal-stepper>


<div mat-dialog-actions align="end">
    <button type="button" mat-flat-button (click)="stepper.previous()" *ngIf="stepper.selectedIndex !== 0">
        Anterior
    </button>

    <button type="button" mat-flat-button [disabled]="!stepper.selected?.stepControl?.valid" (click)="stepper.next()"
        *ngIf="stepper.selectedIndex < stepper.steps.length -1">
        Próximo
    </button>

    <button type="submit" mat-flat-button [disabled]="!isFormValid"
        (click)="onSubmit(formCondutor.values, formCNH?.values)"
        *ngIf="stepper.selectedIndex === stepper.steps.length -1">
        Salvar condutor
    </button>
</div>